import { render } from "./RestoreForm.vue?vue&type=template&id=f4594a20&scoped=true&lang=pug"
import script from "./RestoreForm.vue?vue&type=script&lang=js"
export * from "./RestoreForm.vue?vue&type=script&lang=js"

import "./RestoreForm.vue?vue&type=style&index=0&id=f4594a20&lang=sass&scoped=true"

import exportComponent from "/home/runner/work/valeriya-artist/valeriya-artist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4594a20"]])

export default __exports__